// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home_2HA6Z","logo":"home_logo_6WOFD"};